module.exports = __webpack_public_path__ + "e079c6c962e22b3ec05314c60e99f299.MP3";